import { RefreshControlProps } from 'react-native'
import { CarouselRef } from 'app/hooks/use-carousel-controller'

type BaseType<T> = {} & T

export type ContentCarouselWidth = number | `${number}%`

type BreakpointSizeConfig = {
  width: ContentCarouselWidth
  spacing: number
}

export type SizeConfig = {
  width: ContentCarouselWidth
  spacing: number
  $gtXs: BreakpointSizeConfig
  $gtSm: BreakpointSizeConfig
}

export const defaultSizeConfig: SizeConfig = {
  width: 170,
  spacing: 8,
  $gtXs: {
    width: 277,
    spacing: 16,
  },
  $gtSm: {
    width: 277,
    spacing: 16,
  },
}

export type ContentCarouselProps<T> = {
  renderItem: (item: BaseType<T>, i: number) => React.ReactNode
  keyExtractor: (item: BaseType<T>, i: number) => string
  items: BaseType<T>[]
  refreshControl?: React.ReactElement<RefreshControlProps>
  initialScrollIndex?: number
  controllerRef?: CarouselRef
  sizeConfig?: SizeConfig
}
